import { LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'

import { TARIFF_SERVICE_NAME, TariffService } from '../../../services/tariff'
import { TARIFF_LOCATIONS_SERVICE_NAME, TariffLocationsService } from '../../../services/tariff'
import { GRID_SERVICE_NAME, GridService } from '../../../services/grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'

import { TariffDetailsDirectiveController } from './tariffs-details.directive.controller'

//#region Asset Imports

import './tariffs-details.scss'
import * as TEMPLATE from './tariffs-details.tpl.html'

//#endregion

// #region Setup

export class TariffDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'logger', 'localDictionary', USER_SESSION_SERVICE_NAME, GRID_SERVICE_NAME, TARIFF_SERVICE_NAME, TARIFF_LOCATIONS_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSessionService: UserSessionService,
        gridService: GridService,
        tariffService: TariffService,
        tariffLocationsService: TariffLocationsService
    ) => new TariffDetailsDirectiveController(
        $scope,
        $q,
        $timeout,
        logger,
        localDictionary,
        userSessionService,
        gridService,
        tariffService,
        tariffLocationsService,
        TariffService.REFERENCE_TYPE,
        TariffService.SIMAX_MODULE_NAME
    )]

    controllerAs = '$ctrl'

    template = TEMPLATE
}

// #endregion